import { render, staticRenderFns } from "./RingingDuration.vue?vue&type=template&id=632ae3d0"
import script from "./RingingDuration.vue?vue&type=script&lang=js"
export * from "./RingingDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports